import { __extends } from "tslib";
import React, { Component } from 'react';
var FullscreenExpandCloseButton = /** @class */ (function (_super) {
    __extends(FullscreenExpandCloseButton, _super);
    function FullscreenExpandCloseButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FullscreenExpandCloseButton.prototype.closeButtonCreated = function (buttonElement) {
        this.closeButton = buttonElement;
    };
    FullscreenExpandCloseButton.prototype.componentDidMount = function () {
        if (this.closeButton) {
            this.closeButton.focus && this.closeButton.focus();
        }
    };
    FullscreenExpandCloseButton.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.shouldRefocusOnCloseXButton &&
            !prevProps.shouldRefocusOnCloseXButton) {
            this.focusOnCloseXButton();
        }
    };
    FullscreenExpandCloseButton.prototype.focusOnCloseXButton = function () {
        if (this.closeButton) {
            this.closeButton.focus && this.closeButton.focus();
        }
    };
    FullscreenExpandCloseButton.prototype.render = function () {
        var _this = this;
        return (React.createElement("button", { className: "fullscreen-icon fullscreen-close ".concat(this.props.iconClass), onClick: function () { return _this.props.onClick(); }, tabIndex: this.props.tabIndex, "aria-label": this.props.title, ref: function (button) { return _this.closeButtonCreated(button); } },
            React.createElement("div", { className: "icon-background" })));
    };
    return FullscreenExpandCloseButton;
}(Component));
export default FullscreenExpandCloseButton;
//# sourceMappingURL=FullscreenExpandCloseButton.js.map